import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyUserStatsModal = lazyWithRetry(() => import('./userStatsModal'));
